import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input
} from '@angular/core';
import { RfqTabService } from '@approot/services';

@Component({
  selector: 'app-rfq-offer-formatter',
  templateUrl: './rfq-offer-formatter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RfqOfferFormatterComponent {
  public offerStr = input.required<string>();
  public rfqTabService = inject(RfqTabService);
  public changeRef = inject(ChangeDetectorRef);
  public isGenericMultiHedge: boolean;
  public parts: string[] = [];

  constructor() {
    this.isGenericMultiHedge =
      this.rfqTabService.executionContextType() === 'genericMultiHedge';

    effect(() => {
      const offerStr = this.offerStr();
      const words = offerStr.replace(/\s*Client\s+/, '');
      this.parts = words.split(/\s*\/\s*/g);
      this.changeRef.markForCheck();
    });
  }
}
